// extracted by mini-css-extract-plugin
module.exports = {"price":"Offer_price__3w9Xh"};